(() => {
  const url = document.currentScript?.dataset.badgeFireUrl;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  if (!url || !('IntersectionObserver' in window)) return;
  const connection = navigator.connection;
  if (connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '')) return;

  const selector = 'img[src*="/skull-promo-5x1"]';
  const states = new WeakMap();
  let preload;
  function ready() {
    // One shared, low-priority download; leave every static badge intact on failure.
    if (!preload) preload = new Promise(resolve => {
      const image = new Image();
      image.fetchPriority = 'low';
      image.onload = () => resolve(true);
      image.onerror = () => resolve(false);
      image.src = url;
    });
    return preload;
  }
  function restore(img, state) {
    if (!img.hasAttribute('data-skull-badge-animated')) return;
    img.src = state.src;
    if (state.srcset !== null) img.setAttribute('srcset', state.srcset);
    img.removeAttribute('data-skull-badge-animated');
  }
  async function update(img, state) {
    if (!state.visible || motion.matches || document.hidden) {
      restore(img, state);
      return;
    }
    if (!await ready() || !img.isConnected || !state.visible || motion.matches || document.hidden) return;
    img.removeAttribute('srcset');
    img.src = url;
    img.setAttribute('data-skull-badge-animated', '');
  }
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      const state = states.get(entry.target);
      if (!state) continue;
      state.visible = entry.isIntersecting;
      update(entry.target, state);
    }
  });
  function register(img) {
    if (states.has(img)) return;
    const state = { src: img.getAttribute('src'), srcset: img.getAttribute('srcset'), visible: false };
    states.set(img, state);
    img.addEventListener('error', () => restore(img, state));
    observer.observe(img);
  }
  function scan(node, remove = false) {
    if (node.nodeType !== 1) return;
    const images = [...(node.matches(selector) ? [node] : []), ...node.querySelectorAll(selector)];
    for (const img of images) {
      if (remove) { const state = states.get(img); if (state) restore(img, state); observer.unobserve(img); states.delete(img); }
      else register(img);
    }
  }
  function refresh() {
    for (const img of document.querySelectorAll(selector)) {
      const state = states.get(img);
      if (state) update(img, state);
    }
  }
  function start() {
    scan(document.documentElement);
    // Covers late-loaded roulette, cart and section rendering without polling.
    new MutationObserver(records => {
      for (const record of records) {
        for (const node of record.removedNodes) if (!node.isConnected) scan(node, true);
        for (const node of record.addedNodes) scan(node);
      }
    }).observe(document.body, { childList: true, subtree: true });
    motion.addEventListener('change', refresh);
    document.addEventListener('visibilitychange', refresh);
  }
  function schedule() {
    if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 1500 });
    else setTimeout(start, 250);
  }
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });
})();
